import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCoreTags, getCoreTagsByFieldId } from "./actions";

export const coreTagsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = coreTagsEntityAdapter.getInitialState({
  totalCount: 0,
});

export const coreTagsSlice = createSlice({
  name: "coreTags",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoreTags.fulfilled, (state, action) => {
      if (action.meta.arg.upsert) {
        coreTagsEntityAdapter.upsertMany(state, action.payload?.data?.items || []);
      } else {
        coreTagsEntityAdapter.setAll(state, action.payload?.data?.items || []);
      }
      state.totalCount = action.payload?.data?.totalItems || 0;
    });
    builder.addCase(getCoreTagsByFieldId.fulfilled, (state, action) => {
      if (action.meta.arg.upsert) {
        coreTagsEntityAdapter.upsertMany(state, action.payload?.data?.items || []);
      } else {
        coreTagsEntityAdapter.setAll(state, action.payload?.data?.items || []);
      }
      state.totalCount = action.payload?.data?.totalItems || 0;
    });
  },
});

export default coreTagsSlice.reducer;
